import { apiSlice } from "app/api/apiSlice"

export const overtimeApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['Overtime', 'MyOvertime'],
    endpoints: builder => ({
        getOvertimes: builder.query({
            query: (pageNumber) => {
                return {
                    url: 'hr/overtime',
                    params: {
                        page: pageNumber
                    }
                }
            },
            keepUnusedDataFor: 5,
            providesTags: ['Overtime']
        }),
        getMyOvertimes: builder.query({
            query: (pageNumber) => {
                return {
                    url: 'hr/overtime/me',
                    params: {
                        page: pageNumber
                    }
                }
            },
            keepUnusedDataFor: 5,
            providesTags: ['MyOvertime']
        }),
        createOvertime: builder.mutation({
            query: (
                request
            ) => ({
                url: 'hr/overtime',
                method: 'POST',
                body: request
            }),
            invalidatesTags: ['Overtime']
        }),
    })
})

export const {
    useGetOvertimesQuery,
    useGetMyOvertimesQuery,
    useCreateOvertimeMutation

} = overtimeApiSlice
